import { render, staticRenderFns } from "./creation-2.vue?vue&type=template&id=5d83f119&scoped=true&"
import script from "./creation-2.vue?vue&type=script&lang=js&"
export * from "./creation-2.vue?vue&type=script&lang=js&"
import style0 from "./creation-2.vue?vue&type=style&index=0&id=5d83f119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83f119",
  null
  
)

export default component.exports